import { EndScreen } from './end-screen';
import { EndScreenOrigin, EndScreenTypeValue } from './end-screen-types';
import VASTClient from '../vast/vast-client';

const SMADEX = 'Smadex';

interface CompanionAd {
  content: string;
  clickThrough: string[];
  clickTracking: string[];
  type: EndScreenTypeValue;
}

interface EndScreenVastConfig {
  endScreen?: {
    closeBtn?: {
      delay?: number;
      size?: number;
    };
    forced?: boolean;
    duration?: number;
  };
  closeBtn?: {
    autoCloseDelay?: number;
  };
}

export class EndScreenVast extends EndScreen {
  clickThrough: string[];
  clickTracking: string[];
  content: string;

  vastClient: VASTClient | null;

  _isForced: boolean;
  _isSmadex: boolean;

  constructor({
    config,
    companionAd,
    vastClient
  }: {
    config: EndScreenVastConfig;
    companionAd?: CompanionAd | null;
    vastClient?: VASTClient | null;
  }) {
    super({ config });

    this.clickThrough = [];
    this.clickTracking = [];
    this.content = '';

    if (companionAd) {
      this.content = companionAd.content;
      this.clickThrough = companionAd.clickThrough;
      this.clickTracking = companionAd.clickTracking;
      this.type = companionAd.type;
    }

    this.duration = this._getVastDuration(config);
    this.origin = EndScreenOrigin.VAST;

    this._isForced = Boolean(
      config && config.endScreen && config.endScreen.forced
    );
    this._isSmadex = Boolean(
      vastClient && vastClient.hasAdSystem && vastClient.hasAdSystem(SMADEX)
    );

    this.vastClient = vastClient || null;
  }

  isValid(): boolean {
    const hasContent = Boolean(this.content);
    const hasDuration = this.duration > 0;
    const isAuthorized = this._isForced || this._isSmadex;

    return hasContent && hasDuration && isAuthorized;
  }

  getClickUrl(): string | null {
    return (
      (this.vastClient && this.vastClient.getClickEndScreenUrl(this)) || null
    );
  }

  _getVastDuration(config: EndScreenVastConfig): number {
    const managedDuration = this.duration;
    const vastDuration =
      config && config.endScreen && config.endScreen.duration;

    return managedDuration || vastDuration || 0;
  }
}
